
    export default {
        name: 'PrivacyPolicy',
        computed: {
            privacyPolicy() {
                return this.$store.state.basicData;
            },
        },
    };
